import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    'API-Key': 'E770AD38-D12F-42BE-BCBE-4A67B2DA9630',
  },
})
